// File: src/components/OurMission.jsx
import React from 'react';

export default function OurMission() {
    return (
        <div className="min-h-screen bg-gradient-to-b from-blue-800 via-blue-600 to-blue-100 text-white flex flex-col items-center px-6 py-16">
            <h1 className="text-5xl font-bold text-center mb-6">Innovative business solutions in AFRICA.</h1>

            <p className="text-lg text-gray-200 text-center max-w-2xl mb-8">
                We provide the tools and expertise to help your business thrive in today’s competitive landscape.
            </p>

            <div className="flex gap-4 mb-16">
                <button className="bg-white text-black px-6 py-2 rounded-full font-semibold">Let’s talk</button>
                <button className="bg-black text-white px-6 py-2 rounded-full font-semibold">Our solutions</button>
            </div>

            <p className="uppercase text-sm text-gray-300 tracking-widest mb-6">
                More than 300+ companies trust us
            </p>

            <div className="flex flex-wrap justify-center items-center gap-6 mb-16">
                {['Boltshift', 'Lightbox', 'FeatherDev', 'Spherule', 'GlobalBank'].map((name) => (
                    <div key={name} className="flex items-center gap-2 text-white">
                        <span className="w-6 h-6 bg-white rounded-full"></span> {/* Replace with icon if needed */}
                        <span className="font-medium">{name}</span>
                    </div>
                ))}
            </div>

            <div className="bg-white text-black rounded-xl shadow-xl grid grid-cols-1 md:grid-cols-3 gap-8 p-8 w-full max-w-5xl text-center">
                <div>
                    <h2 className="text-5xl font-bold">95<span className="text-blue-500">%</span></h2>
                    <p className="text-sm mt-2 text-gray-500">Customer Satisfaction Rate</p>
                </div>
                <div>
                    <h2 className="text-5xl font-bold">50<span className="text-blue-500">%</span></h2>
                    <p className="text-sm mt-2 text-gray-500">Average Increase</p>
                </div>
                <div>
                    <h2 className="text-5xl font-bold">30<span className="text-blue-500">+</span></h2>
                    <p className="text-sm mt-2 text-gray-500">Industries Served</p>
                </div>
            </div>
        </div>
    );
}
